module.exports = __webpack_public_path__ + "static/explore_download_icon-59b8a87312bdaa72b58ffa2c56406369.png";